import { Icon } from "@subframe/core";
import { Header, LineItems, PersonInfo, RequestedPayment } from "app/subframe";
import * as React from "react";
import { useOrderComplete } from "./useOrderComplete";
import { getFormatedDuration } from "app/book/bookService/useBookService";
import { format } from "date-fns";
import { Loading } from "app/components/loading/loading";
import { formatLocalTime, formatLocalDate } from "app/utils/timezone";
import { formatUtcToLocalDisplay } from "app/utils/formatDate";
import { PaymentMethodTypes } from "app/order/useOrder";
import { Avatar } from "app/components/avatar/avatar";
import { sum } from "lodash";
import {useEffect} from "react";

export interface OrderCompleteProps {}

export const OrderComplete: React.FC<OrderCompleteProps> = ({}) => {
  const {
    account,
    cart,
    appointmentStartTimes,
    paymentMethod,
    groupedMerchantServices,
    fullTotalCents,
    paidCents,
    pendingCents,
  } = useOrderComplete();

  const formatMoney = (cents: number) => `$${(cents / 100).toFixed(2)}`;


    useEffect(() => {
        console.log('time',appointmentStartTimes)
        console.log('cart',cart)
    }, [cart]);


  const getPaymentMethodElement = () => {
    switch (paymentMethod) {
      case PaymentMethodTypes.CREDIT_CARD:
        return (
          <div className="flex w-full items-center gap-4">
            <div className="flex items-center justify-center gap-2 rounded-md border border-solid border-neutral-50 bg-white px-2 py-1">
              <Icon
                className="text-body font-body text-neutral-900"
                name="FeatherCreditCard"
              />
            </div>
            <span className="text-body font-body text-default-font">
              Paid with Credit Card
            </span>
          </div>
        );
      case PaymentMethodTypes.DEPOSIT:
        return (
          <div className="flex w-full items-center gap-4">
            <div className="flex items-center justify-center gap-2 rounded-md border border-solid border-neutral-50 bg-white px-2 py-1">
              <Icon
                className="text-body font-body text-neutral-900"
                name="FeatherCreditCard"
              />
            </div>
            <span className="text-body font-body text-default-font">
              Deposit Paid
            </span>
          </div>
        );
      case PaymentMethodTypes.PAY_IN_PERSON:
      case PaymentMethodTypes.CASH:
      case PaymentMethodTypes.PRE_AUTH:
        return (
          <div className="flex w-full items-center gap-4">
            <div className="flex items-center justify-center gap-2 rounded-md border border-solid border-neutral-50 bg-white px-2 py-1">
              <Icon
                className="text-body font-body text-neutral-900"
                name="FeatherStore"
              />
            </div>
            <span className="text-body font-body text-default-font">
              Pay in Person
            </span>
          </div>
        );
      default:
        return null;
    }
  };

  const paidWithElement = getPaymentMethodElement();


    if (!account.id || !cart.id)
        return <Loading fullScreen showBackdrop containerClassName="w-full" />;


    return (
    <div className="flex h-[95dvh] my-4 pb-4 grow shrink-0 basis-0 flex-col items-center gap-4 rounded-2xl bg-white overflow-auto shadow-md mobile:w-full mobile:grow mobile:shrink-0 mobile:basis-0">
      <Header
        className="h-auto w-[600px] flex-none mobile:h-auto mobile:w-full mobile:flex-none"
        image={account.logo}
        text={account.name}
      />
      <div className="flex w-[600px] grow shrink-0 basis-0 flex-col items-center gap-4 px-4 pb-20 mobile:w-full mobile:grow mobile:shrink-0 mobile:basis-0 mobile:flex-col mobile:gap-6 mobile:px-2 mobile:py-0">
        <RequestedPayment text="You are all set!" single={true} />
        <div className="flex w-full flex-col items-center gap-4 rounded-md border border-solid border-neutral-100 bg-neutral-0 px-3 py-4">
          {groupedMerchantServices.map((merchant: any, index) => {
            const day = formatLocalDate(cart.startTime!, "MMM d");
            return (
              <>
                <div className="flex w-full items-center gap-4">
                  <PersonInfo
                    className="h-auto w-full flex-none"
                    name={merchant.name}
                  />
                </div>
                {merchant.services.map((service: any, index: number) => (
                  <LineItems
                    title={index === 0 ? "Services" : ""}
                    value={service.title}
                  />
                ))}
                <LineItems
                  title="Duration"
                  value={getFormatedDuration(
                    sum(merchant.services.map((s: any) => s.duration))
                  )}
                />
                <LineItems
                  title="Time"
                  value={`${day} at ${formatLocalTime(cart?.startTime!)}`}
                  additionalInfo=""
                />

                {paidWithElement && (
                  <div className="flex h-px w-full flex-none flex-col items-center gap-2 bg-neutral-100" />
                )}
              </>
            );
          })}
          {paidWithElement}
          {paymentMethod === PaymentMethodTypes.DEPOSIT && (
            <div className="flex w-full flex-col items-center gap-2 pt-2">
              <LineItems title="Total" value={formatMoney(fullTotalCents)} />
              <LineItems title="Paid" value={formatMoney(paidCents)} />
              <LineItems title="Pending" value={formatMoney(pendingCents)} />
            </div>
          )}
        </div>
        <div className="flex w-full flex-col items-center gap-2">
          <span className="w-full text-[18px] font-[500] leading-[28px] text-neutral-900">
            {cart.shop.name}
          </span>
          <div className="flex w-full flex-col items-center gap-1">
            <span className="w-full text-[14px] font-[400] leading-[20px] text-neutral-500">
              {cart.shop.addressLine1}
            </span>
            <span className="w-full text-[14px] font-[400] leading-[20px] text-neutral-500">
              {cart.shop.addressLine2}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
